
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   TextField,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Checkbox,
//   FormControlLabel,
//   IconButton,

//   DialogTitle,
//  Dialog,
//   DialogContent,
//   DialogActions,
//   Grid,
//   Paper,
//   FormGroup
// } from '@mui/material';
// import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { isFuture } from 'date-fns';
// import CloseIcon from '@mui/icons-material/Close';
// import DownloadIcon from '@mui/icons-material/Download';

// const CaseHistoryAdult = () => {
//   const [demographyData, setDemographyData] = useState(null);
//   const [errors, setErrors] = useState({});
//    const [openPasswordModal, setOpenPasswordModal] = useState(false);
//     const [loading, setLoading] = useState(false);
//      const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
//     const [password, setPassword] = useState('');
//     const [downloadFormat, setDownloadFormat] = useState('excel');
//   const [caseHistory, setCaseHistory] = useState({
//     date: null,
//     presentComplaint: '',
//     hearingLossEar: '',
//     hearingLossDurationRight: '',
//     hearingLossDurationLeft: '',
//     hearingLossOnsetRight: '',
//     hearingLossOnsetLeft: '',
//     hearingLossNatureRight: '',
//     hearingLossNatureLeft: '',
//     earPainSide: '',
//     earPainRight: '',
//     earPainLeft: '',
//     blockingSide: '',
//     blockingRight: '',
//     blockingLeft: '',
//     itchingSide: '',
//     itchingRight: '',
//     itchingLeft: '',
//     dischargeSide: '',
//     dischargeRight: '',
//     dischargeLeft: '',
//     fullnessSide: '',
//     fullnessRight: '',
//     fullnessLeft: '',
//     tinnitusEar: '',
//     tinnitusNature: '',
//     tinnitusDurationRight: '',
//     tinnitusDurationLeft: '',
//     tinnitusIrritation: '',
//     hyperacusis: '',
//     hyperacusisDurationRight: '',
//     hyperacusisDurationLeft: '',
//     noiseExposure: '',
//     noiseType: '',
//     noiseDuration: '',
//     vertigo: '',
//     vertigoType: '',
//     vertigoDuration: '',
//     vertigoEpisode2: '',
//     headInjury: '',
//     headInjuryDates: '',
//     headInjuryType: '',
//     headInjuryConsciousness: '',
//     headInjuryVomiting: '',
//     headInjuryHearing: '',
//     systemicIllnesses: [],
//     entFindings: '',
//     earSurgery: '',
//     surgeryDate: '',
//     surgeryEar: '',
//     surgeryDetails: '',
//     audiologicalFindings: '',
//     hearingAidUsage: '',
//     rightDuration: '',
//     leftDuration: '',
//     rightDeviceType: '',
//     leftDeviceType: '',
//     rightDeviceDetails: '',
//     leftDeviceDetails: '',
//     rightConsistencyOfUse: '',
//     leftConsistencyOfUse: '',
//     rightPerceivedBenefit: '',
//     leftPerceivedBenefit: '',
//     audiologicalRehab: ''
//   });

//   useEffect(() => {
//     const data = localStorage.getItem("demography");
//     if (data) {
//       try {
//         const parsedData = JSON.parse(data);

//         // Set patient number based on available data
//         let patientNumber = '';
//         if (parsedData.ipNumber) patientNumber = `IP: ${parsedData.ipNumber}`;
//         else if (parsedData.opNumber) patientNumber = `OP: ${parsedData.opNumber}`;
//         else if (parsedData.internalNumber) patientNumber = `Internal: ${parsedData.internalNumber}`;

//         // Set the demographyData with the patientNumber
//         setDemographyData({ ...parsedData, patientNumber });
//       } catch (error) {
//         console.error("Error parsing demography data:", error);
//       }
//     }
//   }, []);

//   // Rest of your functions (validateField, handleChange, handleDateChange, handleCheckbox, handleSubmit) remain the same

//   const validateField = (name, value) => {
//     let error = '';

//     // Date validation - cannot be future date
//     if (name === 'date' && value && isFuture(new Date(value))) {
//       error = 'Date cannot be in the future';
//     }

//     // Duration fields validation - only numbers allowed
//     if (name.includes('Duration') && value && !/^\d+$/.test(value)) {
//       error = 'Only numbers are allowed for duration fields';
//     }

//     // Update errors state
//     setErrors(prev => ({ ...prev, [name]: error }));

//     return error === '';
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // Validate field if it's a duration field or date
//     if (name.includes('Duration') || name === 'date') {
//       validateField(name, value);
//     }

//     setCaseHistory((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleDateChange = (date) => {
//     const isValid = validateField('date', date);
//     if (isValid) {
//       setCaseHistory((prev) => ({ ...prev, date }));
//     }
//   };

//   const handleCheckbox = (name, value) => (e) => {
//     if (value === 'None') {
//       // If None is selected, clear all other selections
//       setCaseHistory((prev) => ({ ...prev, [name]: e.target.checked ? ['None'] : [] }));
//     } else {
//       // If any other option is selected, remove None if present
//       const newValues = e.target.checked
//         ? [...caseHistory[name].filter(item => item !== 'None'), value]
//         : caseHistory[name].filter((item) => item !== value);
//       setCaseHistory((prev) => ({ ...prev, [name]: newValues }));
//     }
//   };

//   const handleDownloadClick = () => {
//     setOpenPasswordModal(true);
//   };

// const handleDownloadConfirm = async () => {
//   const correctKey = "Varun@6361";

//   // Validate key entered in modal
//   if (password !== correctKey) {
//     alert("Incorrect key! Download canceled.");
//     setPassword('');
//     setOpenPasswordModal(false);
//     return;
//   }

//   setOpenPasswordModal(false);
//   setLoading(true);
//   setSaveStatus({
//     message: `Requesting Case History Adult ${downloadFormat}...`,
//     severity: "info",
//   });

//   try {
//     const resp = await fetch(
//       "http://localhost:5000/api/reports/download-form",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           table: "case_history_adult",
//           formName: "Case_History_Adult",
//           format: downloadFormat,
//           key: password   // 🔥 send KEY instead of password
//         }),
//       }
//     );

//     if (!resp.ok) {
//       const body = await resp.json().catch(() => ({}));
//       setSaveStatus({
//         message: `Failed: ${body.message || resp.statusText}`,
//         severity: "error",
//       });
//       return;
//     }

//     const blob = await resp.blob();
//     const disposition = resp.headers.get("content-disposition") || "";

//     let filename = `Case_History_Adult_${Date.now()}.${
//       downloadFormat === "excel" ? "xlsx" : "pdf"
//     }`;

//     const match = /filename="?([^"]+)"?/.exec(disposition);
//     if (match && match[1]) filename = match[1];

//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = filename;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//     window.URL.revokeObjectURL(url);

//     setSaveStatus({
//       message: `Download started: ${filename}`,
//       severity: "success",
//     });

//   } catch (err) {
//     console.error("Download error:", err);
//     setSaveStatus({
//       message: `Error downloading file: ${err.message}`,
//       severity: "error",
//     });
//   } finally {
//     setLoading(false);
//     setPassword('');
//   }
// };


//   const handlePasswordModalClose = () => {
//     setOpenPasswordModal(false);
//     setPassword('');
//   };
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     // Validate all fields before submission
//     let hasErrors = false;
//     const newErrors = {};

//     // Check date
//     if (caseHistory.date && isFuture(new Date(caseHistory.date))) {
//       newErrors.date = 'Date cannot be in the future';
//       hasErrors = true;
//     }

//     // Check duration fields
//     const durationFields = [
//       'hearingLossDurationRight', 'hearingLossDurationLeft',
//       'tinnitusDurationRight', 'tinnitusDurationLeft',
//       'hyperacusisDurationRight', 'hyperacusisDurationLeft',
//       'noiseDuration', 'vertigoDuration', 'rightDuration', 'leftDuration'
//     ];

//     durationFields.forEach(field => {
//       if (caseHistory[field] && !/^\d+$/.test(caseHistory[field])) {
//         newErrors[field] = 'Only numbers are allowed';
//         hasErrors = true;
//       }
//     });

//     setErrors(newErrors);

//     if (hasErrors) {
//       alert('Please fix the validation errors before submitting.');
//       return;
//     }

//     try {
//       const response = await fetch("http://localhost:5000/api/casehistory/adult", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           // Patient information
//           patientName: demographyData.name,
//           patientNumber: demographyData.patientNumber,
//           patientIpNumber: demographyData.ipNumber || '',
//           patientOpNumber: demographyData.opNumber || '',
//           patientInternalNumber: demographyData.internalNumber || '',

//           // Case history data
//           ...caseHistory
//         }),
//       });

//       if (!response.ok) throw new Error("Failed to save");

//       const data = await response.json();
//       alert("✅ Case history saved!");
//       console.log("Saved:", data);
//     } catch (error) {
//       console.error("Error:", error);
//       alert("❌ Failed to save case history");
//     }
//   };

//   if (!demographyData) return <div>Loading...</div>;

//   return (
//     <Paper elevation={3} sx={{ p: 4, maxWidth: 1200, margin: 'auto', mt: 4, mb: 6 }}>
//         <Box sx={{ position: 'absolute', top: 350, right: 140 }}>
//          <Button
//            variant="contained"
//            color="secondary"
//            startIcon={<DownloadIcon />}
//            onClick={handleDownloadClick}
//            disabled={loading}
//            sx={{ 
//              borderRadius: 2,
//              boxShadow: 2,
//              '&:hover': {
//                boxShadow: 4,
//                transform: 'translateY(-2px)',
//                transition: 'all 0.3s ease'
//              }
//            }}
//          >
//            Download 
//          </Button>
//        </Box>
//       <Typography variant="h5" gutterBottom fontWeight="bold" color="primary">
//         Patient Information
//       </Typography>
//       <Grid container spacing={2} mb={4}>
//         <Grid item xs={12} sm={6}>
//           <Typography><strong>Name:</strong> {demographyData.name}</Typography>
//         </Grid>
//         <Grid item xs={12} sm={3}>
//           <Typography><strong>Age:</strong> {demographyData.age}</Typography>
//         </Grid>
//         <Grid item xs={12} sm={3}>
//           <Typography><strong>Gender:</strong> {demographyData.gender}</Typography>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Typography><strong>Phone:</strong> {demographyData.phone}</Typography>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Typography><strong>Address:</strong> {demographyData.address}</Typography>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Typography><strong>Referred by:</strong> {demographyData.referredBy}</Typography>
//         </Grid>
//         <Grid item xs={12} sm={6}>
//           <Typography><strong>Patient ip_number:</strong> {demographyData.patientNumber}</Typography>
//         </Grid>
//       </Grid>

//       <LocalizationProvider dateAdapter={AdapterDateFns}>
//         <Grid item xs={12} md={6} sx={{ mb: 3 }}>
//           <DatePicker
//             label="Date of Assessment"
//             value={caseHistory.date}

//             onChange={handleDateChange}
//             maxDate={new Date()}
//             renderInput={(params) => (
//               <TextField 
//                 {...params} 
//                 fullWidth 
//                 error={!!errors.date}
//                 helperText={errors.date}
//               />
//             )}
//           />
//         </Grid>
//       </LocalizationProvider>
//       {/* Present Complaint */}
//       <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
//         1. Present Complaint
//       </Typography>

//       <TextField
//         fullWidth
//         multiline
//         rows={3}
//         name="presentComplaint"
//         value={caseHistory.presentComplaint}
//         onChange={handleChange}
//         variant="outlined"
//         sx={{ mb: 4 }}
//       />

//       {/* Signs and Symptoms */}
//       <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
//         2. Signs and Symptoms
//       </Typography>

//       {/* 2a - Hearing Loss */}
//       <Box mb={4}>
//         <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
//           a. Related to hearing loss
//         </Typography>
//         <Grid container spacing={2}>
//           <Grid item xs={12} sm={3}>
//             <FormControl fullWidth variant="outlined">
//               <InputLabel id="hearing-loss-ear-label" shrink={true}>
//                 Hearing Loss Ear
//               </InputLabel>
//               <Select
//                 labelId="hearing-loss-ear-label"
//                 id="hearing-loss-ear"
//                 name="hearingLossEar"
//                 value={caseHistory.hearingLossEar}
//                 onChange={handleChange}
//                 label="Hearing Loss Ear"
//                 displayEmpty
//                 renderValue={value => value || "Select Ear"}
//               >
//                 <MenuItem value="Right">Right</MenuItem>
//                 <MenuItem value="Left">Left</MenuItem>
//                 <MenuItem value="Both">Both</MenuItem>
//                 <MenuItem value="None">None</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           {(caseHistory.hearingLossEar === 'Right' || caseHistory.hearingLossEar === 'Both') && (
//             <>
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Right Duration"
//                   name="hearingLossDurationRight"
//                   value={caseHistory.hearingLossDurationRight}
//                   onChange={handleChange}
//                   variant="outlined"
//                   error={!!errors.hearingLossDurationRight}
//                   helperText={errors.hearingLossDurationRight}
//                   inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <FormControl fullWidth variant="outlined">
//                   <InputLabel shrink={true}>Right Onset</InputLabel>
//                   <Select
//                     name="hearingLossOnsetRight"
//                     value={caseHistory.hearingLossOnsetRight}
//                     onChange={handleChange}
//                     label="Right Onset"
//                     displayEmpty
//                     renderValue={value => value || "Select Onset"}
//                   >
//                     <MenuItem value="Sudden">Sudden</MenuItem>
//                     <MenuItem value="Gradual">Gradual</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <FormControl fullWidth variant="outlined">
//                   <InputLabel shrink={true}>Right Nature</InputLabel>
//                   <Select
//                     name="hearingLossNatureRight"
//                     value={caseHistory.hearingLossNatureRight}
//                     onChange={handleChange}
//                     label="Right Nature"
//                     displayEmpty
//                     renderValue={value => value || "Select Nature"}
//                   >
//                     <MenuItem value="Progressive">Progressive</MenuItem>
//                     <MenuItem value="Fluctuant">Fluctuant</MenuItem>
//                     <MenuItem value="Diplacusis">Diplacusis</MenuItem>
//                     <MenuItem value="Paracusis Willisi">Paracusis Willisi</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </>
//           )}

//           {(caseHistory.hearingLossEar === 'Left' || caseHistory.hearingLossEar === 'Both') && (
//             <>
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Left Duration"
//                   name="hearingLossDurationLeft"
//                   value={caseHistory.hearingLossDurationLeft}
//                   onChange={handleChange}
//                   variant="outlined"
//                   error={!!errors.hearingLossDurationLeft}
//                   helperText={errors.hearingLossDurationLeft}
//                   inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <FormControl fullWidth variant="outlined">
//                   <InputLabel shrink={true}>Left Onset</InputLabel>
//                   <Select
//                     name="hearingLossOnsetLeft"
//                     value={caseHistory.hearingLossOnsetLeft}
//                     onChange={handleChange}
//                     label="Left Onset"
//                     displayEmpty
//                     renderValue={value => value || "Select Onset"}
//                   >
//                     <MenuItem value="Sudden">Sudden</MenuItem>
//                     <MenuItem value="Gradual">Gradual</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12} sm={3}>
//                 <FormControl fullWidth variant="outlined">
//                   <InputLabel shrink={true}>Left Nature</InputLabel>
//                   <Select
//                     name="hearingLossNatureLeft"
//                     value={caseHistory.hearingLossNatureLeft}
//                     onChange={handleChange}
//                     label="Left Nature"
//                     displayEmpty
//                     renderValue={value => value || "Select Nature"}
//                   >
//                     <MenuItem value="Progressive">Progressive</MenuItem>
//                     <MenuItem value="Fluctuant">Fluctuant</MenuItem>
//                     <MenuItem value="Diplacusis">Diplacusis</MenuItem>
//                     <MenuItem value="Paracusis Willisi">Paracusis Willisi</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </>
//           )}
//         </Grid>
//       </Box>

//       {/* 2b - Middle Ear */}
//       <Box mb={4}>
//         <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
//           b. Related to the Middle ear
//         </Typography>

//         {[
//           { label: 'Ear pain', key: 'earPain' },
//           { label: 'Blocking sensation', key: 'blocking' },
//           { label: 'Itching', key: 'itching' },
//           { label: 'Ear discharge', key: 'discharge' },
//           { label: 'Fullness of the ear', key: 'fullness' },
//         ].map(({ label, key }) => {
//           const selected = caseHistory[`${key}Side`] || '';

//           return (
//             <Grid
//               container
//               spacing={2}
//               alignItems="center"
//               mb={2}
//               key={key}
//             >
//               {/* Left column for label */}
//               <Grid item xs={3}>
//                 <Typography>{label}:</Typography>
//               </Grid>

//               {/* Right side for inputs */}
//               <Grid item xs={9}>
//                 <Grid container spacing={2}>
//                   {/* Dropdown */}
//                   <Grid item xs={4}>
//                     <FormControl fullWidth variant="outlined" size="small">
//                       <InputLabel shrink>Select side</InputLabel>
//                       <Select
//                         name={`${key}Side`}
//                         value={selected}
//                         onChange={handleChange}
//                         label="Select side"
//                         displayEmpty
//                         renderValue={(value) => value || "Select"}
//                       >
//                         <MenuItem value="">Select</MenuItem>
//                         <MenuItem value="Right">Right</MenuItem>
//                         <MenuItem value="Left">Left</MenuItem>
//                         <MenuItem value="Both">Both</MenuItem>
//                         <MenuItem value="None">None</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </Grid>

//                   {/* Right Duration */}
//                   {(selected === 'Right' || selected === 'Both') && (
//                     <Grid item xs={4}>
//                       <TextField
//                         fullWidth
//                         label="Right Duration(ear)"
//                         name={`${key}Right`}
//                         value={caseHistory[`${key}Right`] || ''}
//                         onChange={handleChange}
//                         variant="outlined"
//                         size="small"
//                         inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                       />
//                     </Grid>
//                   )}

//                   {/* Left Duration */}
//                   {(selected === 'Left' || selected === 'Both') && (
//                     <Grid item xs={4}>
//                       <TextField
//                         fullWidth
//                         label="Left Duration (ear)"
//                         name={`${key}Left`}
//                         value={caseHistory[`${key}Left`] || ''}
//                         onChange={handleChange}
//                         variant="outlined"
//                         size="small"
//                         inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                       />
//                     </Grid>
//                   )}
//                 </Grid>
//               </Grid>
//             </Grid>
//           );
//         })}
//       </Box>

//       {/* 2c - Others */}
//       <Box mb={3}>
//         <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
//           c. Others
//         </Typography>

//         {/* Tinnitus */}
//         <Box mb={2}>
//           <Typography fontWeight="bold" gutterBottom>
//             Tinnitus
//           </Typography>
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={3}>
//               <FormControl fullWidth variant="outlined">
//                 <InputLabel shrink={true}>Ear</InputLabel>
//                 <Select
//                   name="tinnitusEar"
//                   value={caseHistory.tinnitusEar}
//                   onChange={handleChange}
//                   label="Ear"
//                   displayEmpty
//                   renderValue={value => value || "Select Ear"}
//                 >
//                   <MenuItem value="Right">Right</MenuItem>
//                   <MenuItem value="Left">Left</MenuItem>
//                   <MenuItem value="Both">Both</MenuItem>
//                   <MenuItem value="None">None</MenuItem>
//                   <MenuItem value="Non-localized">Non-localized</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12} sm={3}>
//               <FormControl fullWidth variant="outlined">
//                 <InputLabel shrink={true}>Nature</InputLabel>
//                 <Select
//                   name="tinnitusNature"
//                   value={caseHistory.tinnitusNature}
//                   onChange={handleChange}
//                   label="Nature"
//                   displayEmpty
//                   renderValue={value => value || "Select Nature"}
//                 >
//                   <MenuItem value="Continuous">Continuous</MenuItem>
//                   <MenuItem value="Intermittent">Intermittent</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             {(caseHistory.tinnitusEar === 'Right' || caseHistory.tinnitusEar === 'Both') && (
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Right Duration"
//                   name="tinnitusDurationRight"
//                   value={caseHistory.tinnitusDurationRight}
//                   onChange={handleChange}
//                   variant="outlined"
//                   error={!!errors.tinnitusDurationRight}
//                   helperText={errors.tinnitusDurationRight}
//                   inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                 />
//               </Grid>
//             )}

//             {(caseHistory.tinnitusEar === 'Left' || caseHistory.tinnitusEar === 'Both') && (
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Left Duration"
//                   name="tinnitusDurationLeft"
//                   value={caseHistory.tinnitusDurationLeft}
//                   onChange={handleChange}
//                   variant="outlined"
//                   error={!!errors.tinnitusDurationLeft}
//                   helperText={errors.tinnitusDurationLeft}
//                   inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                 />
//               </Grid>
//             )}

//             {caseHistory.tinnitusEar && caseHistory.tinnitusEar !== 'None' && (
//               <Grid item xs={12} sm={3}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Irritation</InputLabel>
//                   <Select
//                     name="tinnitusIrritation"
//                     value={caseHistory.tinnitusIrritation}
//                     onChange={handleChange}
//                     label="Irritation"
//                     displayEmpty
//                     renderValue={value => value || "Select Irritation"}
//                   >
//                     <MenuItem value="Non Irritating">Non Irritating</MenuItem>
//                     <MenuItem value="Mild">Mild</MenuItem>
//                     <MenuItem value="Moderate">Moderate</MenuItem>
//                     <MenuItem value="Moderately Severe">Moderately Severe</MenuItem>
//                     <MenuItem value="Severe">Severe</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             )}
//           </Grid>
//         </Box>

//         {/* Hyperacusis */}
//         <Box mb={2}>
//           <Typography fontWeight="bold" gutterBottom>
//             Hyperacusis
//           </Typography>
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={3}>
//               <FormControl fullWidth>
//                 <InputLabel shrink={true}>Presence</InputLabel>
//                 <Select
//                   name="hyperacusis"
//                   value={caseHistory.hyperacusis}
//                   onChange={handleChange}
//                   label="Presence"
//                   displayEmpty
//                   renderValue={value => value || "Select Presence"}
//                 >
//                   <MenuItem value="Yes">Yes</MenuItem>
//                   <MenuItem value="No">No</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             {caseHistory.hyperacusis === "Yes" && (
//               <>
//                 <Grid item xs={12} sm={3}>
//                   <TextField
//                     fullWidth
//                     label="Duration (Right)"
//                     name="hyperacusisDurationRight"
//                     value={caseHistory.hyperacusisDurationRight}
//                     onChange={handleChange}
//                     variant="outlined"
//                     error={!!errors.hyperacusisDurationRight}
//                     helperText={errors.hyperacusisDurationRight}
//                     inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={3}>
//                   <TextField
//                     fullWidth
//                     label="Duration (Left)"
//                     name="hyperacusisDurationLeft"
//                     value={caseHistory.hyperacusisDurationLeft}
//                     onChange={handleChange}
//                     variant="outlined"
//                     error={!!errors.hyperacusisDurationLeft}
//                     helperText={errors.hyperacusisDurationLeft}
//                     inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                   />
//                 </Grid>
//               </>
//             )}
//           </Grid>
//         </Box>

//         {/* Noise Exposure */}
//         <Box mb={2}>
//           <Typography fontWeight="bold" gutterBottom>
//             Noise Exposure
//           </Typography>
//           <Grid container spacing={2} alignItems="center">
//             <Grid item xs={12} sm={3}>
//               <FormControl fullWidth>
//                 <InputLabel shrink={true}>Noise Exposure</InputLabel>
//                 <Select
//                   name="noiseExposure"
//                   value={caseHistory.noiseExposure || ''}
//                   onChange={handleChange}
//                   label="Noise Exposure"
//                   displayEmpty
//                   renderValue={value => value || "Select Noise Exposure"}
//                 >
//                   <MenuItem value="">Select</MenuItem>
//                   <MenuItem value="Yes">Yes</MenuItem>
//                   <MenuItem value="No">No</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             {caseHistory.noiseExposure === 'Yes' && (
//               <>
//                 <Grid item xs={12} sm={4}>
//                   <TextField
//                     fullWidth
//                     label="Type of noise(s)"
//                     name="noiseType"
//                     value={caseHistory.noiseType || ''}
//                     onChange={handleChange}
//                     variant="outlined"
//                   />
//                 </Grid>

//                 <Grid item xs={12} sm={4}>
//                   <TextField
//                     fullWidth
//                     label="Duration of exposure"
//                     name="noiseDuration"
//                     value={caseHistory.noiseDuration || ''}
//                     onChange={handleChange}
//                     variant="outlined"
//                     error={!!errors.noiseDuration}
//                     helperText={errors.noiseDuration}
//                     inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                   />
//                 </Grid>
//               </>
//             )}
//           </Grid>
//         </Box>

//         {/* Vertigo */}
//         <Box mb={2}>
//           <Typography fontWeight="bold" gutterBottom>
//             Vertigo
//           </Typography>
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={3}>
//               <FormControl fullWidth>
//                 <InputLabel shrink={true}>Presence</InputLabel>
//                 <Select
//                   name="vertigo"
//                   value={caseHistory.vertigo || ''}
//                   onChange={handleChange}
//                   label="Presence"
//                   displayEmpty
//                   renderValue={value => value || "Select Presence"}
//                 >
//                   <MenuItem value="">Select</MenuItem>
//                   <MenuItem value="Yes">Yes</MenuItem>
//                   <MenuItem value="No">No</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             {caseHistory.vertigo === 'Yes' && (
//               <>
//                 <Grid item xs={12} sm={4}>
//                   <FormControl fullWidth>
//                     <InputLabel shrink={true}>Vertigo Type</InputLabel>
//                     <Select
//                       name="vertigoType"
//                       value={caseHistory.vertigoType || ''}
//                       onChange={handleChange}
//                       label="Vertigo Type"
//                       displayEmpty
//                       renderValue={value => value || "Select Vertigo Type"}
//                     >
//                       <MenuItem value="">Select</MenuItem>
//                       <MenuItem value="positional">Positional</MenuItem>
//                       <MenuItem value="rotatory">Rotatory</MenuItem>
//                       <MenuItem value="light-headedness">Light-headedness</MenuItem>
//                       <MenuItem value="nausea">Nausea</MenuItem>
//                       <MenuItem value="blurring of vision">Blurring of Vision</MenuItem>
//                       <MenuItem value="disequilibrium">Disequilibrium</MenuItem>
//                     </Select>
//                   </FormControl>
//                 </Grid>

//                 {caseHistory.vertigoType && (
//                   <>
//                     <Grid item xs={12} sm={2}>
//                       <TextField
//                         fullWidth
//                         label="Duration"
//                         name="vertigoDuration"
//                         value={caseHistory.vertigoDuration || ''}
//                         onChange={handleChange}
//                         variant="outlined"
//                         error={!!errors.vertigoDuration}
//                         helperText={errors.vertigoDuration}
//                         inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                       />
//                     </Grid>

//                     <Grid item xs={12} sm={2}>
//                       <TextField
//                         fullWidth
//                         label="Episode"
//                         name="vertigoEpisode2"
//                         value={caseHistory.vertigoEpisode2 || ''}
//                         onChange={handleChange}
//                         variant="outlined"
//                       />
//                     </Grid>
//                   </>
//                 )}
//               </>
//             )}
//           </Grid>
//         </Box>
//       </Box>

//       {/* Head Injury */}
//       <Box mb={3}>
//         <Typography fontWeight="bold" gutterBottom>
//           Head Injury
//         </Typography>
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={12} sm={3}>
//             <FormControl fullWidth>
//               <InputLabel shrink={true}>History</InputLabel>
//               <Select
//                 name="headInjury"
//                 value={caseHistory.headInjury || ''}
//                 onChange={handleChange}
//                 label="History"
//                 displayEmpty
//                 renderValue={value => value || "Select History"}
//               >
//                 <MenuItem value="">Select</MenuItem>
//                 <MenuItem value="Yes">Yes</MenuItem>
//                 <MenuItem value="No">No</MenuItem>
//               </Select>
//             </FormControl>
//           </Grid>

//           {caseHistory.headInjury === "Yes" && (
//             <>
//               <Grid item xs={12} sm={3}>
//                 <TextField
//                   fullWidth
//                   label="Date(s)"
//                   name="headInjuryDates"
//                   value={caseHistory.headInjuryDates || ''}
//                   onChange={handleChange}
//                   variant="outlined"
//                   placeholder="e.g., 01/01/2020"
//                 />
//               </Grid>

//               <Grid item xs={12} sm={3}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Loss of Consciousness</InputLabel>
//                   <Select
//                     name="headInjuryConsciousness"
//                     value={caseHistory.headInjuryConsciousness || ''}
//                     onChange={handleChange}
//                     label="Loss of Consciousness"
//                     displayEmpty
//                     renderValue={value => value || "Select Loss of Consciousness"}
//                   >
//                     <MenuItem value="">Select</MenuItem>
//                     <MenuItem value="Yes">Yes</MenuItem>
//                     <MenuItem value="No">No</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={3}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Vomiting</InputLabel>
//                   <Select
//                     name="headInjuryVomiting"
//                     value={caseHistory.headInjuryVomiting || ''}
//                     onChange={handleChange}
//                     label="Vomiting"
//                     displayEmpty
//                     renderValue={value => value || "Select Vomiting"}
//                   >
//                     <MenuItem value="">Select</MenuItem>
//                     <MenuItem value="Yes">Yes</MenuItem>
//                     <MenuItem value="No">No</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>

//               <Grid item xs={12} sm={3}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Hearing Difficulty</InputLabel>
//                   <Select
//                     name="headInjuryHearing"
//                     value={caseHistory.headInjuryHearing || ''}
//                     onChange={handleChange}
//                     label="Hearing Difficulty"
//                     displayEmpty
//                     renderValue={value => value || "Select Hearing Difficulty"}
//                   >
//                     <MenuItem value="">Select</MenuItem>
//                     <MenuItem value="Yes">Yes</MenuItem>
//                     <MenuItem value="No">No</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//             </>
//           )}
//         </Grid>
//       </Box>

//       {/* Systemic Illnesses */}
//       <Box mb={3}>
//         <Typography fontWeight="bold" gutterBottom>
//           Systemic Illnesses
//         </Typography>
//         <FormGroup row sx={{ mb: 2 }}>
//           {["Mumps", "Measles", "Diabetes", "Hypertension", "Infections", "Circulatory", "Renal", "None"].map((illness) => (
//             <FormControlLabel
//               key={illness}
//               control={
//                 <Checkbox
//                   checked={caseHistory.systemicIllnesses.includes(illness)}
//                   onChange={handleCheckbox("systemicIllnesses", illness)}
//                   disabled={illness !== 'None' && caseHistory.systemicIllnesses.includes('None')}
//                 />
//               }
//               label={illness}
//             />
//           ))}
//         </FormGroup>
//       </Box>

//       <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
//         3. Previous/Other Evaluation
//       </Typography>

//       {/* ENT Findings */}
//       <Box mb={3}>
//         <Typography fontWeight="bold" gutterBottom>
//           ENT Findings
//         </Typography>
//         <TextField
//           fullWidth
//           multiline
//           rows={3}
//           name="entFindings"
//           value={caseHistory.entFindings}
//           onChange={handleChange}
//           variant="outlined"
//         />
//       </Box>

//       {/* Ear Surgery */}
//       <Box mb={3}>
//         <Typography fontWeight="bold" gutterBottom>
//           Ear Surgery
//         </Typography>

//         <FormControl fullWidth sx={{ mb: 2 }}>
//           <InputLabel shrink={true}>History</InputLabel>
//           <Select
//             name="earSurgery"
//             value={caseHistory.earSurgery || ''}
//             onChange={handleChange}
//             label="History"
//             displayEmpty
//             renderValue={value => value || "Select History"}
//           >
//             <MenuItem value="">Select</MenuItem>
//             <MenuItem value="Yes">Yes</MenuItem>
//             <MenuItem value="No">No</MenuItem>
//           </Select>
//         </FormControl>

//         {caseHistory.earSurgery === "Yes" && (
//           <Grid container spacing={2}>
//             <Grid item xs={12} sm={4}>
//               <TextField
//                 fullWidth
//                 label="Date of Surgery"
//                 name="surgeryDate"
//                 type="date"
//                 InputLabelProps={{ shrink: true }}
//                 value={caseHistory.surgeryDate || ''}
//                 onChange={handleChange}
//               />
//             </Grid>

//             <Grid item xs={12} sm={4}>
//               <FormControl fullWidth>
//                 <InputLabel shrink={true}>Ear</InputLabel>
//                 <Select
//                   name="surgeryEar"
//                   value={caseHistory.surgeryEar || ''}
//                   onChange={handleChange}
//                   label="Ear"
//                   displayEmpty
//                   renderValue={value => value || "Select Ear"}
//                 >
//                   <MenuItem value="Right">Right</MenuItem>
//                   <MenuItem value="Left">Left</MenuItem>
//                   <MenuItem value="Both">Both</MenuItem>
//                 </Select>
//               </FormControl>
//             </Grid>

//             <Grid item xs={12}>
//               <TextField
//                 fullWidth
//                 multiline
//                 rows={3}
//                 label="Surgery Details"
//                 name="surgeryDetails"
//                 value={caseHistory.surgeryDetails || ''}
//                 onChange={handleChange}
//                 variant="outlined"
//               />
//             </Grid>
//           </Grid>
//         )}
//       </Box>

//       {/* Audiological Findings */}
//       <Box mb={3}>
//         <Typography fontWeight="bold" gutterBottom>
//           Audiological Findings
//         </Typography>
//         <TextField
//           fullWidth
//           multiline
//           rows={3}
//           name="audiologicalFindings"
//           value={caseHistory.audiologicalFindings}
//           onChange={handleChange}
//           variant="outlined"
//         />
//       </Box>

//       {/* Hearing Aid Usage */}
//       <Box mb={4}>
//         <Typography fontWeight="bold" gutterBottom>
//           Hearing aids / Other devices
//         </Typography>

//         {/* Usage Dropdown */}
//         <FormControl fullWidth sx={{ mb: 2 }}>
//           <InputLabel shrink={true}>Usage</InputLabel>
//           <Select
//             name="hearingAidUsage"
//             value={caseHistory.hearingAidUsage || ''}
//             onChange={handleChange}
//             label="Usage"
//             displayEmpty
//             renderValue={value => value || "Select Usage"}
//           >
//             <MenuItem value="Worn in the past">Worn in the past</MenuItem>
//             <MenuItem value="Wearing currently">Wearing currently</MenuItem>
//             <MenuItem value="Never worn">Never worn</MenuItem>
//           </Select>
//         </FormControl>

//         {(caseHistory.hearingAidUsage === "Worn in the past" || caseHistory.hearingAidUsage === "Wearing currently") && (
//           <>
//             {/* Right Hearing Aid Section */}
//             <Typography variant="subtitle1" fontWeight="medium" gutterBottom sx={{ mt: 2 }}>
//               Right Hearing Aid
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Right Duration"
//                   name="rightDuration"
//                   value={caseHistory.rightDuration || ''}
//                   onChange={handleChange}
//                   error={!!errors.rightDuration}
//                   helperText={errors.rightDuration}
//                   inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Right Device Type</InputLabel>
//                   <Select
//                     name="rightDeviceType"
//                     value={caseHistory.rightDeviceType || ''}
//                     onChange={handleChange}
//                     label="Right Device Type"
//                     displayEmpty
//                     renderValue={value => value || "Select Type"}
//                   >
//                     <MenuItem value="Body level">Body level</MenuItem>
//                     <MenuItem value="BTE">BTE</MenuItem>
//                     <MenuItem value="ITE">ITE</MenuItem>
//                     <MenuItem value="ITC">ITC</MenuItem>
//                     <MenuItem value="CIC">CIC</MenuItem>
//                     <MenuItem value="Others">Others</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Right Device Details"
//                   name="rightDeviceDetails"
//                   value={caseHistory.rightDeviceDetails || ''}
//                   onChange={handleChange}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Right Consistency of use"
//                   name="rightConsistencyOfUse"
//                   value={caseHistory.rightConsistencyOfUse || ''}
//                   onChange={handleChange}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Right Perceived benefit"
//                   name="rightPerceivedBenefit"
//                   value={caseHistory.rightPerceivedBenefit || ''}
//                   onChange={handleChange}
//                 />
//               </Grid>
//             </Grid>

//             {/* Left Hearing Aid Section */}
//             <Typography variant="subtitle1" fontWeight="medium" gutterBottom>
//               Left Hearing Aid
//             </Typography>
//             <Grid container spacing={2} sx={{ mb: 3 }}>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Left Duration"
//                   name="leftDuration"
//                   value={caseHistory.leftDuration || ''}
//                   onChange={handleChange}
//                   error={!!errors.leftDuration}
//                   helperText={errors.leftDuration}
//                   inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <FormControl fullWidth>
//                   <InputLabel shrink={true}>Left Device Type</InputLabel>
//                   <Select
//                     name="leftDeviceType"
//                     value={caseHistory.leftDeviceType || ''}
//                     onChange={handleChange}
//                     label="Left Device Type"
//                     displayEmpty
//                     renderValue={value => value || "Select Type"}
//                   >
//                     <MenuItem value="Body level">Body level</MenuItem>
//                     <MenuItem value="BTE">BTE</MenuItem>
//                     <MenuItem value="ITE">ITE</MenuItem>
//                     <MenuItem value="ITC">ITC</MenuItem>
//                     <MenuItem value="CIC">CIC</MenuItem>
//                     <MenuItem value="Others">Others</MenuItem>
//                   </Select>
//                 </FormControl>
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Left Device Details"
//                   name="leftDeviceDetails"
//                   value={caseHistory.leftDeviceDetails || ''}
//                   onChange={handleChange}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Left Consistency of use"
//                   name="leftConsistencyOfUse"
//                   value={caseHistory.leftConsistencyOfUse || ''}
//                   onChange={handleChange}
//                 />
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Left Perceived benefit"
//                   name="leftPerceivedBenefit"
//                   value={caseHistory.leftPerceivedBenefit || ''}
//                   onChange={handleChange}
//                 />
//               </Grid>
//             </Grid>
//           </>
//         )}

//         {/* Audiological Rehabilitation */}
//         <FormControl fullWidth sx={{ mb: 2 }}>
//           <InputLabel shrink={true}>Audiological Rehabilitation</InputLabel>
//           <Select
//             name="audiologicalRehab"
//             value={caseHistory.audiologicalRehab || ''}
//             onChange={handleChange}
//             label="Audiological Rehabilitation"
//             displayEmpty
//             renderValue={value => value || "Select Audiological Rehabilitation"}
//           >
//             <MenuItem value="Yes">Yes</MenuItem>
//             <MenuItem value="No">No</MenuItem>
//           </Select>
//         </FormControl>
//       </Box>
//    {/* Password Modal */}
//       <Dialog 
//         open={openPasswordModal} 
//         onClose={handlePasswordModalClose}
//         maxWidth="xs"
//         fullWidth
//       >
//         <DialogTitle>
//           Download Data
//           <IconButton
//             aria-label="close"
//             onClick={handlePasswordModalClose}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ mt: 2, mb: 2 }}>
//             <TextField
//               fullWidth
//               label="Password"
//               type="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               variant="outlined"
//               sx={{ mb: 3 }}
//             />
//             <FormControl fullWidth>
//               <InputLabel>Format</InputLabel>
//               <Select
//                 value={downloadFormat}
//                 onChange={(e) => setDownloadFormat(e.target.value)}
//                 label="Format"
//               >
//                 <MenuItem value="excel">Excel</MenuItem>
//                 <MenuItem value="pdf">PDF</MenuItem>
//               </Select>
//             </FormControl>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button onClick={handlePasswordModalClose} color="inherit">
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleDownloadConfirm} 
//             variant="contained" 
//             color="primary"
//             disabled={!password}
//           >
//             Download
//           </Button>
//         </DialogActions>
//       </Dialog>
//       {/* Submit Button */}
//       <Box textAlign="right">
//         <Button variant="contained" color="primary" onClick={handleSubmit} size="large">
//           Submit
//         </Button>
//       </Box>
//     </Paper>
//   );
// };

// export default CaseHistoryAdult;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Paper,
  FormGroup,
  Card,
  CardContent,
  Divider,
  Stack,
  Container
} from '@mui/material';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { isFuture } from 'date-fns';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import NoteAddIcon from '@mui/icons-material/NoteAdd';

// Initial state for case history
const initialCaseHistory = {
  date: null,
  presentComplaint: '',
  hearingLossEar: '',
  hearingLossDurationRight: '',
  hearingLossDurationLeft: '',
  hearingLossOnsetRight: '',
  hearingLossOnsetLeft: '',
  hearingLossNatureRight: '',
  hearingLossNatureLeft: '',
  earPainSide: '',
  earPainRight: '',
  earPainLeft: '',
  blockingSide: '',
  blockingRight: '',
  blockingLeft: '',
  itchingSide: '',
  itchingRight: '',
  itchingLeft: '',
  dischargeSide: '',
  dischargeRight: '',
  dischargeLeft: '',
  fullnessSide: '',
  fullnessRight: '',
  fullnessLeft: '',
  tinnitusEar: '',
  tinnitusNature: '',
  tinnitusDurationRight: '',
  tinnitusDurationLeft: '',
  tinnitusIrritation: '',
  hyperacusis: '',
  hyperacusisDurationRight: '',
  hyperacusisDurationLeft: '',
  noiseExposure: '',
  noiseType: '',
  noiseDuration: '',
  vertigo: '',
  vertigoType: '',
  vertigoDuration: '',
  vertigoEpisode2: '',
  headInjury: '',
  headInjuryDates: '',
  headInjuryType: '',
  headInjuryConsciousness: '',
  headInjuryVomiting: '',
  headInjuryHearing: '',
  systemicIllnesses: [],
  entFindings: '',
  earSurgery: '',
  surgeryDate: '',
  surgeryEar: '',
  surgeryDetails: '',
  audiologicalFindings: '',
  hearingAidUsage: '',
  rightDuration: '',
  leftDuration: '',
  rightDeviceType: '',
  leftDeviceType: '',
  rightDeviceDetails: '',
  leftDeviceDetails: '',
  rightConsistencyOfUse: '',
  leftConsistencyOfUse: '',
  rightPerceivedBenefit: '',
  leftPerceivedBenefit: '',
  audiologicalRehab: ''
};

const CaseHistoryAdult = () => {
  const [demographyData, setDemographyData] = useState(null);
  const [errors, setErrors] = useState({});
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ message: '', severity: '' });
  const [password, setPassword] = useState('');
  const [downloadFormat, setDownloadFormat] = useState('excel');
  const [caseHistory, setCaseHistory] = useState(initialCaseHistory);

  useEffect(() => {
    const data = localStorage.getItem("demography");
    if (data) {
      try {
        const parsedData = JSON.parse(data);

        let patientNumber = '';
        if (parsedData.ipNumber) patientNumber = `IP: ${parsedData.ipNumber}`;
        else if (parsedData.opNumber) patientNumber = `OP: ${parsedData.opNumber}`;
        else if (parsedData.internalNumber) patientNumber = `Internal: ${parsedData.internalNumber}`;

        setDemographyData({ ...parsedData, patientNumber });
      } catch (error) {
        console.error("Error parsing demography data:", error);
      }
    }
  }, []);

  const validateField = (name, value) => {
    let error = '';

    if (name === 'date' && value && isFuture(new Date(value))) {
      error = 'Date cannot be in the future';
    }

    if (name.includes('Duration') && value && !/^\d+$/.test(value)) {
      error = 'Only numbers are allowed for duration fields';
    }

    setErrors(prev => ({ ...prev, [name]: error }));

    return error === '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes('Duration') || name === 'date') {
      validateField(name, value);
    }

    setCaseHistory((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (date) => {
    const isValid = validateField('date', date);
    if (isValid) {
      setCaseHistory((prev) => ({ ...prev, date }));
    }
  };

  const handleCheckbox = (name, value) => (e) => {
    if (value === 'None') {
      setCaseHistory((prev) => ({ ...prev, [name]: e.target.checked ? ['None'] : [] }));
    } else {
      const newValues = e.target.checked
        ? [...caseHistory[name].filter(item => item !== 'None'), value]
        : caseHistory[name].filter((item) => item !== value);
      setCaseHistory((prev) => ({ ...prev, [name]: newValues }));
    }
  };

  const handleDownloadClick = () => {
    setOpenPasswordModal(true);
  };

  const handleDownloadConfirm = async () => {
    const correctKey = "Varun@6361";

    if (password !== correctKey) {
      alert("Incorrect key! Download canceled.");
      setPassword('');
      setOpenPasswordModal(false);
      return;
    }

    setOpenPasswordModal(false);
    setLoading(true);
    setSaveStatus({
      message: `Requesting Case History Adult ${downloadFormat}...`,
      severity: "info",
    });

    try {
      const resp = await fetch(
        `${process.env.REACT_APP_API_URL}/api/reports/download-form`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            table: "case_history_adult",
            formName: "Case_History_Adult",
            format: downloadFormat,
            key: password
          }),
        }
      );

      if (!resp.ok) {
        const body = await resp.json().catch(() => ({}));
        setSaveStatus({
          message: `Failed: ${body.message || resp.statusText}`,
          severity: "error",
        });
        return;
      }

      const blob = await resp.blob();
      const disposition = resp.headers.get("content-disposition") || "";

      let filename = `Case_History_Adult_${Date.now()}.${downloadFormat === "excel" ? "xlsx" : "pdf"
        }`;

      const match = /filename="?([^"]+)"?/.exec(disposition);
      if (match && match[1]) filename = match[1];

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setSaveStatus({
        message: `Download started: ${filename}`,
        severity: "success",
      });

    } catch (err) {
      console.error("Download error:", err);
      setSaveStatus({
        message: `Error downloading file: ${err.message}`,
        severity: "error",
      });
    } finally {
      setLoading(false);
      setPassword('');
    }
  };

  const handlePasswordModalClose = () => {
    setOpenPasswordModal(false);
    setPassword('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasErrors = false;
    const newErrors = {};

    if (caseHistory.date && isFuture(new Date(caseHistory.date))) {
      newErrors.date = 'Date cannot be in the future';
      hasErrors = true;
    }

    const durationFields = [
      'hearingLossDurationRight', 'hearingLossDurationLeft',
      'tinnitusDurationRight', 'tinnitusDurationLeft',
      'hyperacusisDurationRight', 'hyperacusisDurationLeft',
      'noiseDuration', 'vertigoDuration', 'rightDuration', 'leftDuration'
    ];

    durationFields.forEach(field => {
      if (caseHistory[field] && !/^\d+$/.test(caseHistory[field])) {
        newErrors[field] = 'Only numbers are allowed';
        hasErrors = true;
      }
    });

    setErrors(newErrors);

    if (hasErrors) {
      alert('Please fix the validation errors before submitting.');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/casehistory/adult`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          patientName: demographyData.name,
          patientNumber: demographyData.patientNumber,
          patientIpNumber: demographyData.ipNumber || '',
          patientOpNumber: demographyData.opNumber || '',
          patientInternalNumber: demographyData.internalNumber || '',
          ...caseHistory
        }),
      });

      if (!response.ok) throw new Error("Failed to save");

      const data = await response.json();
      alert("✅ Case history saved successfully!");

      // Reset form after successful submission
      setCaseHistory(initialCaseHistory);
      setErrors({});

      console.log("Saved:", data);
    } catch (error) {
      console.error("Error:", error);
      alert("❌ Failed to save case history");
    }
  };

  if (!demographyData) return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Typography>Loading patient data...</Typography>
    </Box>
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Container maxWidth="xl">
        <Box sx={{ py: 4 }}>
          {/* Header Section */}
          <Paper elevation={0} sx={{ p: 3, mb: 4, border: '1px solid #e0e0e0' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <NoteAddIcon sx={{ fontSize: 40, color: 'primary.main' }} />
                <Box>
                  <Typography variant="h4" fontWeight={600} color="text.primary">
                    Case History - Adult
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    Complete patient assessment form
                  </Typography>
                </Box>
              </Stack>

              <Button
                variant="outlined"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadClick}
                disabled={loading}
                sx={{
                  borderRadius: 2,
                  px: 3,
                  textTransform: 'none'
                }}
              >
                Download Form
              </Button>
            </Stack>



            {/* Assessment Date */}
            <Box sx={{ mb: 2 }}>
              <DatePicker
                label="Date of Assessment"
                value={caseHistory.date}
                onChange={handleDateChange}
                maxDate={new Date()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{ width: 300 }}
                    error={!!errors.date}
                    helperText={errors.date}
                  />
                )}
              />
            </Box>
          </Paper>
          <Paper elevation={2} sx={{ p: 3, mb: 3, backgroundColor: '#e3f2fd', borderRadius: 2 }}>
            <Typography variant="h5" gutterBottom fontWeight="bold" color="secondary">
              Patient Information
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>Name:</strong> {demographyData.name}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>Age:</strong> {demographyData.age}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>IP Number:</strong> {demographyData.ip_number}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>OP Number:</strong> {demographyData.op_number}</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <Typography><strong>Phone:</strong> {demographyData.phone}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography><strong>Address:</strong> {demographyData.address}</Typography>
              </Grid>
            </Grid>
          </Paper>

          {/* Main Form */}
          <Paper elevation={0} sx={{ p: 4, border: '1px solid #e0e0e0' }}>
            {/* 1. Present Complaint */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                1. Present Complaint
              </Typography>

              <TextField
                fullWidth
                multiline
                rows={4}
                name="presentComplaint"
                value={caseHistory.presentComplaint}
                onChange={handleChange}
                variant="outlined"
                placeholder="Describe the patient's main complaints..."
              />
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* 2. Signs and Symptoms */}
            <Box sx={{ mb: 5 }}>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                2. Signs and Symptoms
              </Typography>

              {/* 2a - Hearing Loss (fixed: Right and Left rows render properly when 'Both' is selected) */}
              <Card variant="outlined" sx={{ mb: 4 }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                    a. Hearing Loss Related
                  </Typography>

                  <Grid container spacing={3}>
                    {/* Affected Ear select */}
                    <Grid item xs={12} md={3}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel id="hearing-loss-ear-label" shrink>Affected Ear</InputLabel>
                        <Select
                          labelId="hearing-loss-ear-label"
                          name="hearingLossEar"
                          value={caseHistory.hearingLossEar || ''}
                          onChange={handleChange}
                          label="Affected Ear"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select Ear</em></MenuItem>
                          <MenuItem value="Right">Right</MenuItem>
                          <MenuItem value="Left">Left</MenuItem>
                          <MenuItem value="Both">Both</MenuItem>
                          <MenuItem value="None">None</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* RIGHT / LEFT / BOTH container — keeps select in the left column and renders rows on the right */}
                    <Grid item xs={12} md={9}>
                      {/* RIGHT only */}
                      {caseHistory.hearingLossEar === 'Right' && (
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label="Duration (Right)"
                              name="hearingLossDurationRight"
                              value={caseHistory.hearingLossDurationRight || ''}
                              onChange={handleChange}
                              variant="outlined"
                              size="small"
                              error={!!errors.hearingLossDurationRight}
                              helperText={errors.hearingLossDurationRight}
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                              <InputLabel shrink>Onset (Right)</InputLabel>
                              <Select
                                name="hearingLossOnsetRight"
                                value={caseHistory.hearingLossOnsetRight || ''}
                                onChange={handleChange}
                                label="Onset (Right)"
                                displayEmpty
                              >
                                <MenuItem value=""><em>Select Onset</em></MenuItem>
                                <MenuItem value="Sudden">Sudden</MenuItem>
                                <MenuItem value="Gradual">Gradual</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                              <InputLabel shrink>Nature (Right)</InputLabel>
                              <Select
                                name="hearingLossNatureRight"
                                value={caseHistory.hearingLossNatureRight || ''}
                                onChange={handleChange}
                                label="Nature (Right)"
                                displayEmpty
                              >
                                <MenuItem value=""><em>Select Nature</em></MenuItem>
                                <MenuItem value="Progressive">Progressive</MenuItem>
                                <MenuItem value="Fluctuant">Fluctuant</MenuItem>
                                <MenuItem value="Diplacusis">Diplacusis</MenuItem>
                                <MenuItem value="Paracusis Willisi">Paracusis Willisi</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      )}

                      {/* LEFT only */}
                      {caseHistory.hearingLossEar === 'Left' && (
                        <Grid container spacing={2}>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label="Duration (Left)"
                              name="hearingLossDurationLeft"
                              value={caseHistory.hearingLossDurationLeft || ''}
                              onChange={handleChange}
                              variant="outlined"
                              size="small"
                              error={!!errors.hearingLossDurationLeft}
                              helperText={errors.hearingLossDurationLeft}
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                              <InputLabel shrink>Onset (Left)</InputLabel>
                              <Select
                                name="hearingLossOnsetLeft"
                                value={caseHistory.hearingLossOnsetLeft || ''}
                                onChange={handleChange}
                                label="Onset (Left)"
                                displayEmpty
                              >
                                <MenuItem value=""><em>Select Onset</em></MenuItem>
                                <MenuItem value="Sudden">Sudden</MenuItem>
                                <MenuItem value="Gradual">Gradual</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                              <InputLabel shrink>Nature (Left)</InputLabel>
                              <Select
                                name="hearingLossNatureLeft"
                                value={caseHistory.hearingLossNatureLeft || ''}
                                onChange={handleChange}
                                label="Nature (Left)"
                                displayEmpty
                              >
                                <MenuItem value=""><em>Select Nature</em></MenuItem>
                                <MenuItem value="Progressive">Progressive</MenuItem>
                                <MenuItem value="Fluctuant">Fluctuant</MenuItem>
                                <MenuItem value="Diplacusis">Diplacusis</MenuItem>
                                <MenuItem value="Paracusis Willisi">Paracusis Willisi</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        </Grid>
                      )}

                      {/* BOTH selected: show Right row first, then a small divider, then Left row */}
                      {caseHistory.hearingLossEar === 'Both' && (
                        <Box>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>Right</Typography>
                          <Grid container spacing={2} sx={{ mb: 2 }}>
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                label="Duration (Right)"
                                name="hearingLossDurationRight"
                                value={caseHistory.hearingLossDurationRight || ''}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                error={!!errors.hearingLossDurationRight}
                                helperText={errors.hearingLossDurationRight}
                              />
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel shrink>Onset (Right)</InputLabel>
                                <Select
                                  name="hearingLossOnsetRight"
                                  value={caseHistory.hearingLossOnsetRight || ''}
                                  onChange={handleChange}
                                  label="Onset (Right)"
                                  displayEmpty
                                >
                                  <MenuItem value=""><em>Select Onset</em></MenuItem>
                                  <MenuItem value="Sudden">Sudden</MenuItem>
                                  <MenuItem value="Gradual">Gradual</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel shrink>Nature (Right)</InputLabel>
                                <Select
                                  name="hearingLossNatureRight"
                                  value={caseHistory.hearingLossNatureRight || ''}
                                  onChange={handleChange}
                                  label="Nature (Right)"
                                  displayEmpty
                                >
                                  <MenuItem value=""><em>Select Nature</em></MenuItem>
                                  <MenuItem value="Progressive">Progressive</MenuItem>
                                  <MenuItem value="Fluctuant">Fluctuant</MenuItem>
                                  <MenuItem value="Diplacusis">Diplacusis</MenuItem>
                                  <MenuItem value="Paracusis Willisi">Paracusis Willisi</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>

                          <Divider sx={{ mb: 2 }} />

                          <Typography variant="subtitle2" sx={{ mb: 1 }}>Left</Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                              <TextField
                                fullWidth
                                label="Duration (Left)"
                                name="hearingLossDurationLeft"
                                value={caseHistory.hearingLossDurationLeft || ''}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                error={!!errors.hearingLossDurationLeft}
                                helperText={errors.hearingLossDurationLeft}
                              />
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel shrink>Onset (Left)</InputLabel>
                                <Select
                                  name="hearingLossOnsetLeft"
                                  value={caseHistory.hearingLossOnsetLeft || ''}
                                  onChange={handleChange}
                                  label="Onset (Left)"
                                  displayEmpty
                                >
                                  <MenuItem value=""><em>Select Onset</em></MenuItem>
                                  <MenuItem value="Sudden">Sudden</MenuItem>
                                  <MenuItem value="Gradual">Gradual</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>

                            <Grid item xs={12} md={4}>
                              <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel shrink>Nature (Left)</InputLabel>
                                <Select
                                  name="hearingLossNatureLeft"
                                  value={caseHistory.hearingLossNatureLeft || ''}
                                  onChange={handleChange}
                                  label="Nature (Left)"
                                  displayEmpty
                                >
                                  <MenuItem value=""><em>Select Nature</em></MenuItem>
                                  <MenuItem value="Progressive">Progressive</MenuItem>
                                  <MenuItem value="Fluctuant">Fluctuant</MenuItem>
                                  <MenuItem value="Diplacusis">Diplacusis</MenuItem>
                                  <MenuItem value="Paracusis Willisi">Paracusis Willisi</MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Grid>
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>

              {/* 2b - Middle Ear (stacked, conditional durations) */}
              <Card variant="outlined" sx={{ mb: 4 }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                    b. Middle Ear Related Symptoms
                  </Typography>

                  <Grid container spacing={2}>
                    {[
                      { label: 'Ear pain', key: 'earPain' },
                      { label: 'Blocking sensation', key: 'blocking' },
                      { label: 'Itching', key: 'itching' },
                      { label: 'Ear discharge', key: 'discharge' },
                      { label: 'Fullness of the ear', key: 'fullness' },
                    ].map(({ label, key }) => {
                      const selected = caseHistory[`${key}Side`] || '';

                      return (
                        <Grid item xs={12} key={key}>
                          <Box
                            sx={{
                              p: 2,
                              border: '1px solid',
                              borderColor: 'divider',
                              borderRadius: 2,
                              backgroundColor: 'background.paper',
                              minHeight: 140, // consistent card height — adjust as needed
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'flex-start',
                              gap: 1,
                            }}
                          >
                            <Typography fontWeight={600}>{label}</Typography>

                            {/* Select — styled to match TextField height */}
                            <FormControl
                              fullWidth
                              variant="outlined"
                              size="small"
                              sx={{ '& .MuiInputBase-root': { minHeight: 44 } }}
                            >
                              <InputLabel shrink htmlFor={`${key}Side`}>Select side</InputLabel>
                              <Select
                                name={`${key}Side`}
                                value={selected}
                                onChange={handleChange}
                                label="Select side"
                                displayEmpty
                                sx={{ mt: 1 }}
                              >
                                <MenuItem value=""><em>Select</em></MenuItem>
                                <MenuItem value="Right">Right</MenuItem>
                                <MenuItem value="Left">Left</MenuItem>
                                <MenuItem value="Both">Both</MenuItem>
                                <MenuItem value="None">None</MenuItem>
                              </Select>
                            </FormControl>

                            {/* Conditionally rendered duration fields (only appear when applicable) */}
                            {(selected === 'Right' || selected === 'Both') && (
                              <TextField
                                fullWidth
                                label="Duration (Right)"
                                name={`${key}Right`}
                                value={caseHistory[`${key}Right`] || ''}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                sx={{ '& .MuiInputBase-root': { minHeight: 44 } }}
                              />
                            )}

                            {(selected === 'Left' || selected === 'Both') && (
                              <TextField
                                fullWidth
                                label="Duration (Left)"
                                name={`${key}Left`}
                                value={caseHistory[`${key}Left`] || ''}
                                onChange={handleChange}
                                variant="outlined"
                                size="small"
                                sx={{ '& .MuiInputBase-root': { minHeight: 44 } }}
                              />
                            )}
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                </CardContent>
              </Card>

              {/* 2c - Others */}
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom sx={{ mb: 3 }}>
                    c. Other Symptoms
                  </Typography>

                  {/* Tinnitus */}
                  <Box sx={{ mb: 4 }}>
                    <Typography fontWeight={600} gutterBottom>
                      Tinnitus
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel shrink={true}>Ear</InputLabel>
                          <Select
                            name="tinnitusEar"
                            value={caseHistory.tinnitusEar}
                            onChange={handleChange}
                            label="Ear"
                            displayEmpty
                          >
                            <MenuItem value=""><em>Select Ear</em></MenuItem>
                            <MenuItem value="Right">Right</MenuItem>
                            <MenuItem value="Left">Left</MenuItem>
                            <MenuItem value="Both">Both</MenuItem>
                            <MenuItem value="None">None</MenuItem>
                            <MenuItem value="Non-localized">Non-localized</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel shrink={true}>Nature</InputLabel>
                          <Select
                            name="tinnitusNature"
                            value={caseHistory.tinnitusNature}
                            onChange={handleChange}
                            label="Nature"
                            displayEmpty
                          >
                            <MenuItem value=""><em>Select Nature</em></MenuItem>
                            <MenuItem value="Continuous">Continuous</MenuItem>
                            <MenuItem value="Intermittent">Intermittent</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {(caseHistory.tinnitusEar === 'Right' || caseHistory.tinnitusEar === 'Both') && (
                        <Grid item xs={12} md={3}>
                          <TextField
                            fullWidth
                            label="Duration (Right)"
                            name="tinnitusDurationRight"
                            value={caseHistory.tinnitusDurationRight}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            error={!!errors.tinnitusDurationRight}
                            helperText={errors.tinnitusDurationRight}
                          />
                        </Grid>
                      )}

                      {(caseHistory.tinnitusEar === 'Left' || caseHistory.tinnitusEar === 'Both') && (
                        <Grid item xs={12} md={3}>
                          <TextField
                            fullWidth
                            label="Duration (Left)"
                            name="tinnitusDurationLeft"
                            value={caseHistory.tinnitusDurationLeft}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            error={!!errors.tinnitusDurationLeft}
                            helperText={errors.tinnitusDurationLeft}
                          />
                        </Grid>
                      )}

                      {caseHistory.tinnitusEar && caseHistory.tinnitusEar !== 'None' && (
                        <Grid item xs={12} md={3}>
                          <FormControl fullWidth size="small">
                            <InputLabel shrink={true}>Irritation Level</InputLabel>
                            <Select
                              name="tinnitusIrritation"
                              value={caseHistory.tinnitusIrritation}
                              onChange={handleChange}
                              label="Irritation Level"
                              displayEmpty
                            >

                              <MenuItem value=""><em>Select Level</em></MenuItem>
                              <MenuItem value="Non Irritating">Non Irritating</MenuItem>
                              <MenuItem value="Mild">Mild</MenuItem>
                              <MenuItem value="Moderate">Moderate</MenuItem>
                              <MenuItem value="Moderately Severe">Moderately Severe</MenuItem>
                              <MenuItem value="Severe">Severe</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                      )}
                    </Grid>
                  </Box>

                  {/* Hyperacusis */}
                  <Box sx={{ mb: 4 }}>
                    <Typography fontWeight={600} gutterBottom>
                      Hyperacusis
                    </Typography>
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth size="small">
                          <InputLabel shrink={true}>Presence</InputLabel>
                          <Select
                            name="hyperacusis"
                            value={caseHistory.hyperacusis}
                            onChange={handleChange}
                            label="Presence"
                            displayEmpty
                          >
                            <MenuItem value=""><em>Select</em></MenuItem>
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {caseHistory.hyperacusis === "Yes" && (
                        <>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Duration (Right)"
                              name="hyperacusisDurationRight"
                              value={caseHistory.hyperacusisDurationRight}
                              onChange={handleChange}
                              variant="outlined"
                              size="small"
                              error={!!errors.hyperacusisDurationRight}
                              helperText={errors.hyperacusisDurationRight}
                            />
                          </Grid>

                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Duration (Left)"
                              name="hyperacusisDurationLeft"
                              value={caseHistory.hyperacusisDurationLeft}
                              onChange={handleChange}
                              variant="outlined"
                              size="small"
                              error={!!errors.hyperacusisDurationLeft}
                              helperText={errors.hyperacusisDurationLeft}
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Box>

                  {/* Noise Exposure */}
                  <Box sx={{ mb: 4 }}>
                    <Typography fontWeight={600} gutterBottom>
                      Noise Exposure
                    </Typography>
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth size="small">
                          <InputLabel shrink={true}>Exposure History</InputLabel>
                          <Select
                            name="noiseExposure"
                            value={caseHistory.noiseExposure || ''}
                            onChange={handleChange}
                            label="Exposure History"
                            displayEmpty
                          >
                            <MenuItem value=""><em>Select</em></MenuItem>
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {caseHistory.noiseExposure === 'Yes' && (
                        <>
                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label="Type of noise(s)"
                              name="noiseType"
                              value={caseHistory.noiseType || ''}
                              onChange={handleChange}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>

                          <Grid item xs={12} md={4}>
                            <TextField
                              fullWidth
                              label="Duration (years)"
                              name="noiseDuration"
                              value={caseHistory.noiseDuration || ''}
                              onChange={handleChange}
                              variant="outlined"
                              size="small"
                              error={!!errors.noiseDuration}
                              helperText={errors.noiseDuration}
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Box>

                  {/* Vertigo */}
                  <Box sx={{ mb: 4 }}>
                    <Typography fontWeight={600} gutterBottom>
                      Vertigo
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth size="small">
                          <InputLabel shrink={true}>Presence</InputLabel>
                          <Select
                            name="vertigo"
                            value={caseHistory.vertigo || ''}
                            onChange={handleChange}
                            label="Presence"
                            displayEmpty
                          >
                            <MenuItem value=""><em>Select</em></MenuItem>
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {caseHistory.vertigo === 'Yes' && (
                        <>
                          <Grid item xs={12} md={4}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Type</InputLabel>
                              <Select
                                name="vertigoType"
                                value={caseHistory.vertigoType || ''}
                                onChange={handleChange}
                                label="Type"
                                displayEmpty
                              >

                                <MenuItem value=""><em>Select Type</em></MenuItem>
                                <MenuItem value="positional">Positional</MenuItem>
                                <MenuItem value="rotatory">Rotatory</MenuItem>
                                <MenuItem value="light-headedness">Light-headedness</MenuItem>
                                <MenuItem value="nausea">Nausea</MenuItem>
                                <MenuItem value="blurring of vision">Blurring of Vision</MenuItem>
                                <MenuItem value="disequilibrium">Disequilibrium</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          {caseHistory.vertigoType && (
                            <>
                              <Grid item xs={12} md={2}>
                                <TextField
                                  fullWidth
                                  label="Duration"
                                  name="vertigoDuration"
                                  value={caseHistory.vertigoDuration || ''}
                                  onChange={handleChange}
                                  variant="outlined"
                                  size="small"
                                  error={!!errors.vertigoDuration}
                                  helperText={errors.vertigoDuration}
                                />
                              </Grid>

                              <Grid item xs={12} md={2}>
                                <TextField
                                  fullWidth
                                  label="Episode"
                                  name="vertigoEpisode2"
                                  value={caseHistory.vertigoEpisode2 || ''}
                                  onChange={handleChange}
                                  variant="outlined"
                                  size="small"
                                />
                              </Grid>
                            </>
                          )}
                        </>
                      )}
                    </Grid>
                  </Box>

                  {/* Head Injury */}
                  <Box sx={{ mb: 3 }}>
                    <Typography fontWeight={600} gutterBottom>
                      Head Injury History
                    </Typography>
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={12} md={3}>
                        <FormControl fullWidth size="small">
                          <InputLabel shrink={true}>History</InputLabel>
                          <Select
                            name="headInjury"
                            value={caseHistory.headInjury || ''}
                            onChange={handleChange}
                            label="History"
                            displayEmpty
                          >
                            <MenuItem value=""><em>Select</em></MenuItem>
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      {caseHistory.headInjury === "Yes" && (
                        <>
                          <Grid item xs={12} md={3}>
                            <TextField
                              fullWidth
                              label="Date(s)"
                              name="headInjuryDates"
                              value={caseHistory.headInjuryDates || ''}
                              onChange={handleChange}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>

                          <Grid item xs={12} md={3}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Loss of Consciousness</InputLabel>
                              <Select
                                name="headInjuryConsciousness"
                                value={caseHistory.headInjuryConsciousness || ''}
                                onChange={handleChange}
                                label="Loss of Consciousness"
                                displayEmpty
                              >
                                <MenuItem value=""><em>Select</em></MenuItem>
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={3}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Vomiting</InputLabel>
                              <Select
                                name="headInjuryVomiting"
                                value={caseHistory.headInjuryVomiting || ''}
                                onChange={handleChange}
                                label="Vomiting"
                                displayEmpty
                              >

                                <MenuItem value=""><em>Select</em></MenuItem>
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={3}>
                            <FormControl fullWidth size="small">
                              <InputLabel shrink={true}>Hearing Difficulty</InputLabel>
                              <Select
                                name="headInjuryHearing"
                                value={caseHistory.headInjuryHearing || ''}
                                onChange={handleChange}
                                label="Hearing Difficulty"
                                displayEmpty
                              >
                                <MenuItem value=""><em>Select</em></MenuItem>
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Box>

                  {/* Systemic Illnesses */}
                  <Box>
                    <Typography fontWeight={600} gutterBottom>
                      Systemic Illnesses
                    </Typography>
                    <FormGroup row sx={{ flexWrap: 'wrap', gap: 1 }}>
                      {["Mumps", "Measles", "Diabetes", "Hypertension", "Infections", "Circulatory", "Renal", "None"].map((illness) => (
                        <Box key={illness} sx={{ border: '1px solid #e0e0e0', borderRadius: 1 }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={caseHistory.systemicIllnesses.includes(illness)}
                                onChange={handleCheckbox("systemicIllnesses", illness)}
                                disabled={illness !== 'None' && caseHistory.systemicIllnesses.includes('None')}
                              />
                            }
                            label={illness}
                            sx={{ mx: 1 }}
                          />
                        </Box>
                      ))}
                    </FormGroup>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            <Divider sx={{ my: 4 }} />

            {/* 3. Previous/Other Evaluation */}
            <Box>
              <Typography variant="h6" fontWeight={600} gutterBottom sx={{ mb: 4 }}>
                3. Previous/Other Evaluation
              </Typography>

              {/* ENT Findings */}
              <Card variant="outlined" sx={{ mb: 4 }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    ENT Findings
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    name="entFindings"
                    value={caseHistory.entFindings}
                    onChange={handleChange}
                    variant="outlined"
                    placeholder="Enter ENT findings..."
                  />
                </CardContent>
              </Card>

              {/* Ear Surgery */}
              <Card variant="outlined" sx={{ mb: 4 }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Ear Surgery History
                  </Typography>

                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>Surgery History</InputLabel>
                        <Select
                          name="earSurgery"
                          value={caseHistory.earSurgery || ''}
                          onChange={handleChange}
                          label="Surgery History"
                          displayEmpty
                        >
                          <MenuItem value=""><em>Select History</em></MenuItem>
                          <MenuItem value="Yes">Yes</MenuItem>
                          <MenuItem value="No">No</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {caseHistory.earSurgery === "Yes" && (
                    <Box sx={{ mt: 3 }}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            label="Date of Surgery"
                            name="surgeryDate"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={caseHistory.surgeryDate || ''}
                            onChange={handleChange}
                          />
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <FormControl fullWidth>
                            <InputLabel shrink={true}>Ear</InputLabel>
                            <Select
                              name="surgeryEar"
                              value={caseHistory.surgeryEar || ''}
                              onChange={handleChange}
                              label="Ear"
                              displayEmpty
                            >
                              <MenuItem value=""><em>Select Ear</em></MenuItem>
                              <MenuItem value="Right">Right</MenuItem>
                              <MenuItem value="Left">Left</MenuItem>
                              <MenuItem value="Both">Both</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            multiline
                            rows={3}
                            label="Surgery Details"
                            name="surgeryDetails"
                            value={caseHistory.surgeryDetails || ''}
                            onChange={handleChange}
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </CardContent>
              </Card>

              {/* Audiological Findings */}
              <Card variant="outlined" sx={{ mb: 4 }}>
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Audiological Findings
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    name="audiologicalFindings"
                    value={caseHistory.audiologicalFindings}
                    onChange={handleChange}
                    variant="outlined"
                    placeholder="Enter audiological findings..."
                  />
                </CardContent>
              </Card>

              {/* Hearing Aid Usage */}
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                    Hearing Aid / Device Usage
                  </Typography>

                  <Grid container spacing={3}>
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth>
                        <InputLabel shrink={true}>Usage Status</InputLabel>
                        <Select
                          name="hearingAidUsage"
                          value={caseHistory.hearingAidUsage || ''}
                          onChange={handleChange}
                          label="Usage Status"
                          displayEmpty
                        >

                          <MenuItem value=""><em>Select Status</em></MenuItem>
                          <MenuItem value="Worn in the past">Worn in the past</MenuItem>
                          <MenuItem value="Wearing currently">Wearing currently</MenuItem>
                          <MenuItem value="Never worn">Never worn</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>

                  {(caseHistory.hearingAidUsage === "Worn in the past" || caseHistory.hearingAidUsage === "Wearing currently") && (
                    <>
                      {/* Right Hearing Aid Section */}
                      <Box sx={{ mt: 4 }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                          Right Hearing Aid Details
                        </Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Duration (months)"
                              name="rightDuration"
                              value={caseHistory.rightDuration || ''}
                              onChange={handleChange}
                              error={!!errors.rightDuration}
                              helperText={errors.rightDuration}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                              <InputLabel shrink={true}>Device Type</InputLabel>
                              <Select
                                name="rightDeviceType"
                                value={caseHistory.rightDeviceType || ''}
                                onChange={handleChange}
                                label="Device Type"
                                displayEmpty
                              >

                                <MenuItem value=""><em>Select Type</em></MenuItem>
                                <MenuItem value="Body level">Body level</MenuItem>
                                <MenuItem value="BTE">BTE</MenuItem>
                                <MenuItem value="ITE">ITE</MenuItem>
                                <MenuItem value="ITC">ITC</MenuItem>
                                <MenuItem value="CIC">CIC</MenuItem>
                                <MenuItem value="Others">Others</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Device Details"
                              name="rightDeviceDetails"
                              value={caseHistory.rightDeviceDetails || ''}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Consistency of Use"
                              name="rightConsistencyOfUse"
                              value={caseHistory.rightConsistencyOfUse || ''}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Perceived Benefit"
                              name="rightPerceivedBenefit"
                              value={caseHistory.rightPerceivedBenefit || ''}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      </Box>

                      {/* Left Hearing Aid Section */}
                      <Box sx={{ mt: 4 }}>
                        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                          Left Hearing Aid Details
                        </Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Duration (months)"
                              name="leftDuration"
                              value={caseHistory.leftDuration || ''}
                              onChange={handleChange}
                              error={!!errors.leftDuration}
                              helperText={errors.leftDuration}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <FormControl fullWidth>
                              <InputLabel shrink={true}>Device Type</InputLabel>
                              <Select
                                name="leftDeviceType"
                                value={caseHistory.leftDeviceType || ''}
                                onChange={handleChange}
                                label="Device Type"
                                displayEmpty
                              >
                                <MenuItem value=""><em>Select Type</em></MenuItem>
                                <MenuItem value="Body level">Body level</MenuItem>
                                <MenuItem value="BTE">BTE</MenuItem>
                                <MenuItem value="ITE">ITE</MenuItem>
                                <MenuItem value="ITC">ITC</MenuItem>
                                <MenuItem value="CIC">CIC</MenuItem>
                                <MenuItem value="Others">Others</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              fullWidth
                              label="Device Details"
                              name="leftDeviceDetails"
                              value={caseHistory.leftDeviceDetails || ''}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Consistency of Use"
                              name="leftConsistencyOfUse"
                              value={caseHistory.leftConsistencyOfUse || ''}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextField
                              fullWidth
                              label="Perceived Benefit"
                              name="leftPerceivedBenefit"
                              value={caseHistory.leftPerceivedBenefit || ''}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </>
                  )}

                  <Box sx={{ mt: 4 }}>
                    <FormControl fullWidth>
                      <InputLabel shrink={true}>Audiological Rehabilitation</InputLabel>
                      <Select
                        name="audiologicalRehab"
                        value={caseHistory.audiologicalRehab || ''}
                        onChange={handleChange}
                        label="Audiological Rehabilitation"
                        displayEmpty
                      >
                        <MenuItem value=""><em>Select</em></MenuItem>
                        <MenuItem value="Yes">Yes</MenuItem>
                        <MenuItem value="No">No</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            {/* Submit Button */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 6 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                size="large"
                sx={{
                  px: 6,
                  py: 1.5,
                  fontSize: '1.1rem',
                  textTransform: 'none'
                }}
              >
                Submit Case History
              </Button>
            </Box>
          </Paper>
        </Box>

        {/* Download Modal */}
        <Dialog
          open={openPasswordModal}
          onClose={handlePasswordModalClose}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">Download Data</Typography>
            <IconButton
              aria-label="close"
              onClick={handlePasswordModalClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 2, mb: 2 }}>
              <TextField
                fullWidth
                label="Enter Security Key"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                variant="outlined"
                sx={{ mb: 3 }}
                helperText="Enter the security key to download data"
              />
              <FormControl fullWidth>
                <InputLabel>Download Format</InputLabel>
                <Select
                  value={downloadFormat}
                  onChange={(e) => setDownloadFormat(e.target.value)}
                  label="Download Format"
                >
                  <MenuItem value="excel">Excel (.xlsx)</MenuItem>
                  <MenuItem value="pdf">PDF (.pdf)</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePasswordModalClose} color="inherit">
              Cancel
            </Button>
            <Button
              onClick={handleDownloadConfirm}
              variant="contained"
              color="primary"
              disabled={!password}
            >
              Download
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </LocalizationProvider>
  );
};

export default CaseHistoryAdult;